export const filter = {
    id: "",
    name: "",
    percent: "",
    search: "",
    created_at: "",
    updated_at: "",
};
